module.exports = __webpack_public_path__ + "static/3-9173beb0edae6ee09fb7c321d9018199.jpg";